(function () {
  function getScrollOffset() {
    var headerHeight = parseInt(
      getComputedStyle(document.documentElement).getPropertyValue('--theme-sticky-header-height'),
      10
    );

    return (Number.isFinite(headerHeight) ? headerHeight : 0) + 20;
  }

  function scrollToReviews(target) {
    var top = target.getBoundingClientRect().top + window.scrollY - getScrollOffset();

    window.scrollTo({
      top: Math.max(top, 0),
      behavior: 'smooth'
    });
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest('.js-product-reviews-link');

    if (!link) {
      return;
    }

    var target =
      document.getElementById('klaviyo-product-reviews-wrapper') ||
      document.getElementById('product-reviews');

    if (!target) {
      return;
    }

    event.preventDefault();
    scrollToReviews(target);

    if (window.history && window.history.replaceState) {
      window.history.replaceState(null, '', '#klaviyo-product-reviews-wrapper');
    }
  });
})();
